var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBusiness = function SvgBusiness(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "business_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".business_svg__business0{fill:#8ca4b0}.business_svg__business2{fill:#dde5e8}.business_svg__business3{fill:#f2f6f7}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m182.1 662.3 156.7 155.9c8.5 8.5 24 131.8 15.5 140.4l-31 31c-8.5 8.5-22.5 8.5-31 0L276 973.3l-124.2-124C101.4 798.8 50.2 748.4 26.2 723.6l-15.5-15.5c-8.5-8.5-8.5-22.5 0-31l31-31c8.5-8.6 131.8 7.7 140.4 16.2M240.2 97c-23.3 0-42.7 19.4-42.7 42.7s19.4 42.7 42.7 42.7 42.7-19.4 42.7-42.7S263.5 97 240.2 97m131.9 46.5c-23.3 0-42.7 19.4-42.7 42.7s19.4 42.7 42.7 42.7 42.7-19.4 42.7-42.7-19.5-42.7-42.7-42.7m484.7 477c0-23.3-19.4-42.7-42.7-42.7s-42.7 19.4-42.7 42.7 19.4 42.7 42.7 42.7 42.7-18.7 42.7-42.7m3.9 89.2c-23.3 0-42.7 19.4-42.7 42.7s19.4 42.7 42.7 42.7 42.7-19.4 42.7-42.7c-.1-23.4-19.5-42.7-42.7-42.7",
    className: "business_svg__business0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m584.6 262.9 153.6 153.6c17.1 17.1 186.1 489.4 169.1 506.4L846 984.2c-17.1 17.1-44.2 17.1-61.3 0l-339-430.4L16.1 216.4c-17.1-17.1-17.1-44.2 0-61.3l61.3-61.3c17-17 490.1 152.1 507.2 169.1",
    style: {
      fill: "#ccd7dc"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M978.5 22.5c42.7 42.7 4.7 148.9-45.8 200.1L378.3 776.4c-51.2 51.2-234.2 166-276.9 123.3S173.5 674 224.7 622.8L778.5 68.3c51.1-51.2 157.4-88.4 200-45.8",
    className: "business_svg__business2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m262.7 660 553.7-553.7c43.4-43.4 126.4-76.8 176-60.5-3.1-9.3-7.8-17.1-14-24-42.7-42.7-148.9-4.7-200.1 46.5L224.7 622c-51.2 51.2-165.2 234.2-123.3 276.9 6.2 6.2 16.3 9.3 28.7 9.3.8-66.7 89.2-204.7 132.6-248.2",
    className: "business_svg__business3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m275.1 419.6 87.6 68.2 224.1-224.1-2.3-2.3c-4.7-4.7-48.1-22.5-107-45z",
    style: {
      fill: "#bac7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514 640.6 269.9 343.6c15.5 15.5 40.3 16.3 57.4 3.1L543.5 611.2zm-124.1-183L11.4 161.3c-11.6 17.1-10.1 40.3 4.7 55.1l344.3 269.9z",
    style: {
      fill: "#ed7402"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.4 486.3 29.5-28.7-85.3-66.7-29.5 28.7z",
    style: {
      fill: "#cc6b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.5 67.2c42.2 0 76.3 34.2 76.3 76.3h20.5c2.9-8 5-16.4 5-25.4 0-42.2-34.2-76.3-76.3-76.3-9 0-17.5 2.1-25.4 5v20.4z",
    style: {
      fill: "#3162ab"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.3 677.8 49.5 898.9c-5.3 9.4-3.3 21.2 4.8 28.3l21.2 18.9c7.3 6.5 17.8 7.6 26.3 2.9l236.9-130.8z",
    className: "business_svg__business2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.4 705.5 65.3 937s-29.9-13-10.5-47.6L192.6 666l125-136.2z",
    className: "business_svg__business3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export default ForwardRef;